import { Text, View } from "@react-pdf/renderer";

export function parseNotesToItems(html: string): string[] {
  if (!html) return [];
  const liMatches = html.match(/<li[^>]*>(.*?)<\/li>/gi);
  if (liMatches && liMatches.length > 0) {
    return liMatches.map((li) => li.replace(/<[^>]+>/g, "").trim()).filter(Boolean);
  }
  const stripped = html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  return stripped ? [stripped] : [];
}

/** Inline notes box — sits beside the customer info block (portrait reports). */
export function NotesSideBox({ notes }: { notes?: string }) {
  const items = parseNotesToItems(notes ?? "");
  if (items.length === 0) return null;
  return (
    <View
      style={{
        flex: 1,
        alignSelf: "flex-start",
        marginLeft: 14,
        backgroundColor: "#EFEFEF",
        borderRadius: 8,
        padding: 10,
      }}
    >
      <Text style={{ fontSize: 9, fontWeight: "bold", color: "#505050", marginBottom: 8 }}>
        Notes:
      </Text>
      {items.map((item, i) => (
        <View key={i} style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={{ fontSize: 8, color: "#505050", marginRight: 4 }}>•</Text>
          <Text style={{ fontSize: 8, color: "#505050", flex: 1 }}>{item}</Text>
        </View>
      ))}
    </View>
  );
}

/** Bottom notes strip — sits below the table on the last page (table reports). */
export function NotesBottomBlock({ notes }: { notes?: string }) {
  const items = parseNotesToItems(notes ?? "");
  if (items.length === 0) return null;
  return (
    <View
      style={{
        marginTop: 10,
        backgroundColor: "#EFEFEF",
        borderRadius: 6,
        padding: 8,
      }}
    >
      <Text style={{ fontSize: 9, fontWeight: "bold", color: "#505050", marginBottom: 6 }}>
        Notes:
      </Text>
      <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 4 }}>
        {items.map((item, i) => (
          <View key={i} style={{ flexDirection: "row", width: "48%", marginBottom: 3 }}>
            <Text style={{ fontSize: 8, color: "#505050", marginRight: 4 }}>•</Text>
            <Text style={{ fontSize: 8, color: "#505050", flex: 1 }}>{item}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}
